import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiBarGraphItem from './KpiBarGraphItem';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as kpiModels from '../../../models/kpiModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiGraph extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang:this.props.lang,
            userDataKpi: this.props.userDataKpi,
            kpiData: this.props.kpiData,
            locale: appHelper.getLocalData(this.props.kpiData),
            activeKpi: {},
            activeKpiLocale: {},
            updateChart: false,
            currentTooltipId: ""
        };

        this.setZoneMarkers = this.setZoneMarkers.bind(this);
        this.setCurrentToolTipId = this.setCurrentToolTipId.bind(this);
        this.clearCurrentToolTipId = this.clearCurrentToolTipId.bind(this);
    }

    componentDidMount() {
        this.setZoneMarkers();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userDataKpi !== nextProps.userDataKpi) {
            this.setState({userDataKpi: Object.assign({}, nextProps.userDataKpi), updateChart: true});
        }

        if (this.state.kpiData !== nextProps.kpiData) {
            this.setState({kpiData: Object.assign({}, nextProps.kpiData), locale: appHelper.getLocalData(nextProps.kpiData) ,updateChart: true});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpiData),
                updateChart: true
            });
        }
    }

    componentDidUpdate(){
        if(this.state.updateChart){
            this.setZoneMarkers();
        }
    }

    setZoneMarkers() {
        let yellowZoneHeight = dataHelper.getRangePercentage(this.props.userDataKpi.min,this.props.userDataKpi.max, this.props.userDataKpi.yellow);
        let greenZoneHeight = dataHelper.getRangePercentage(this.props.userDataKpi.min,this.props.userDataKpi.max, this.props.userDataKpi.green);
        let yellowZoneMarker = this.refs.yellowZoneMarker;
        let greenZoneMarker = this.refs.greenZoneMarker;
        let minZoneMarker = this.refs.minZoneMarker;
        let maxZoneMarker = this.refs.maxZoneMarker;
        TweenLite.set(yellowZoneMarker, {height: `${yellowZoneHeight}%`});
        TweenLite.set(greenZoneMarker, {height: `${greenZoneHeight}%`});
        TweenLite.set(minZoneMarker, {height: `2%`});
        TweenLite.set(maxZoneMarker, {height: `100%`});
        /*TweenLite.from(yellowZoneMarker, 0.3, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        });
        TweenLite.from(greenZoneMarker, 0.3, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        });*/
        this.setState({
            updateChart: false,
        });
    }

    setCurrentToolTipId(tooltipId){
        this.setState({
            currentTooltipId: tooltipId
        });
    }

    clearCurrentToolTipId(){
        this.setState({
            currentTooltipId: ""
        });
    }

    render() {
        return (
            <div className="kpi-graph-container" ref={`kpi-graph`} onMouseLeave={this.clearCurrentToolTipId}>
                <div className="graph-y-title">{this.state.locale.long_title}</div>
                <div className="kpi-graph">
                    <div className="zone-marker" ref="maxZoneMarker">
                        <div className="zone-marker-label">{this.props.userDataKpi.max}</div>
                    </div>
                    <div className="yellow-zone-marker" ref="yellowZoneMarker">
                        <div className="zone-marker-label">{this.props.userDataKpi.yellow}</div>
                    </div>
                    <div className="green-zone-marker" ref="greenZoneMarker">
                        <div className="zone-marker-label">{this.props.userDataKpi.green}</div>
                    </div>
                    <div className="zone-marker" ref="minZoneMarker">
                        <div className="zone-marker-label">{this.props.userDataKpi.min}</div>
                    </div>
                    <div className="bar-graph-items">
                        {this.state.userDataKpi.history.map(kpi =>
                            <KpiBarGraphItem key={`${kpi.asset_id}`}
                                             kpi_id={this.state.userDataKpi.kpi_id}
                                             kpiData={this.state.kpiData}
                                             userDataKpi={kpi}
                                             min={this.props.userDataKpi.min}
                                             max={this.props.userDataKpi.max}
                                             totalItems={this.props.userDataKpi.history.length}
                                             index={appHelper.getArrayObjectIndexByKey(this.state.userDataKpi.history,"option_id",kpi.option_id)}
                                             currentTooltipId={this.state.currentTooltipId}
                                             onSetTooltip={this.setCurrentToolTipId} />
                        )}
                    </div>
                </div>

            </div>
        );
    }
}
KpiGraph.propTypes = {
    userDataKpi: PropTypes.object.isRequired,
    kpiData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
};

KpiGraph.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KpiGraph);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiGraph.js
 **/